import { lazy } from "react";
import Loadable from "app/components/Loadable";

const DailyTimeRecord = Loadable(lazy(() => import("./page")));

const DailyTimeRecordRoutes = [{ path: "/Dtr", element: <DailyTimeRecord /> }];

export default DailyTimeRecordRoutes;
